import ApisService from './index'
import {
  ISearchRequestAdd,
  ISearchRequestImport,
} from '../interfaces/searchRequestInterfaces'
import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'

export function createSearchRequest(data: ISearchRequestAdd) {
  try {
    return ApisService.post('/yeucautim/create-yeucautim', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function updateSearchRequest(data: ISearchRequestAdd) {
  try {
    return ApisService.put('/yeucautim/' + data.id + '/update-yeucautim', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getDetailSearchRequest(id: string) {
  try {
    return ApisService.get('/yeucautim/' + id + '/get-chitiet-yeucautim')
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getListSearchRequest(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/yeucautim/filter-yeucautim', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteSearchRequest(id: string) {
  try {
    return ApisService.delete('/yeucautim/' + id + '/delete-yeucautim')
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteMultISearchRequest(idArr: Array<string>) {
  try {
    return ApisService.delete('/yeucautim/bulk-delete-yeucautim', { data: idArr })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function importSearchRequest(data: Array<ISearchRequestImport>) {
  try {
    return ApisService.post('/yeucautim/import-yeucautim', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function confirmSearchRequest(id: string) {
  try {
    return ApisService.put('/yeucautim/' + id + '/dongy-dontim')
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function rejectAllSearchRequest(id: string, lyDo: string) {
  try {
    return ApisService.put('/yeucautim/' + id + '/tuchoi-tatca-dontim', {lyDo})
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function cancelSearchRequest(id: string) {
  try {
    return ApisService.put('/yeucautim/' + id + '/huy-yeucautim')
  } catch (err) {
    handleError(err)
    throw err
  }
}
